import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';
import { SubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSectionHeader';

export const StyledHeaderGrid = styled(Grid)`
  ${SubSectionHeader} {
    margin: 0;
  }
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;
